import React from 'react';
import { ButtonContainer, NavButton } from './styles';

const MobileNavigationButtons = ({ onImageSelect }) => {
  const navigateImage = (direction) => {
    onImageSelect(direction);
  };

  return (
    <ButtonContainer>
      <NavButton onClick={() => navigateImage(-1)}>&lt;</NavButton>
      <NavButton onClick={() => navigateImage(1)}>&gt;</NavButton>
    </ButtonContainer>
  );
};

export default MobileNavigationButtons;
